import MainLayout from '@/layouts/MainLayout.vue'

export default {
  path: '/carbon-footprint',
  component: MainLayout,
  redirect: '/carbon-footprint/home',
  meta: { module: 'carbonFootprint', title: '碳足迹核算' },
  children: [
    {
      path: 'home',
      name: 'CarbonFootprintHome',
      component: () => import('@/views/carbon-footprint/Home.vue'),
      meta: { title: '首页' }
    },
    {
      path: 'model',
      name: 'CarbonFootprintModel',
      component: () => import('@/views/carbon-footprint/Model.vue'),
      meta: { title: '模型管理' }
    },
    {
      path: 'model/detail',
      name: 'CarbonFootprintModelDetail',
      component: () => import('@/views/carbon-footprint/ModelDetail.vue'),
      meta: { title: '模型详情' }
    },
    {
      path: 'accounting',
      name: 'CarbonFootprintAccounting',
      component: () => import('@/views/carbon-footprint/Accounting.vue'),
      meta: { title: '足迹核算' }
    },
    {
      path: 'evaluation',
      name: 'CarbonFootprintEvaluation',
      component: () => import('@/views/carbon-footprint/Evaluation.vue'),
      meta: { title: '报告评价' }
    },
    {
      path: 'label',
      name: 'CarbonFootprintLabel',
      component: () => import('@/views/carbon-footprint/Label.vue'),
      meta: { title: '碳标签' }
    },
    {
      path: 'database',
      name: 'CarbonFootprintDatabase',
      component: () => import('@/views/carbon-footprint/Database.vue'),
      meta: { title: '背景数据库' }
    }
  ]
}
